module.exports = {
  Monday: '星期一',
  Tuesday: '星期二',
  Wednesday: '星期三',
  Thursday: '星期四',
  Friday: '星期五',
  Saturday: '星期六',
  Sunday: '星期日',
  CollectSuccess: '取件成功',
  StoreSuccess: '上架成功',
  ReturnSuccess: '退件成功',
  Success: '成功',
  Exp: '逾期',
  UnStored: '未上架',
  Stored: '已上架',
  ExpiredReturned: '逾期已退',
  Returns: '退件',
  Returned: '退件已退',
  Arriving: '即將到達',
  Collected: '已取件',
  Created: '已創建',
  Cancelled: '已取消',
  Store: '上架',
  Collect: '取件',
  common: {
    Back: '返回',
    locationName: '',
    Home: '首頁',
    Save: '保存',
    Confirm: '確認',
    ScanNext: '掃描下一個',
    Cancel: '取消',
    ScanBarcode: '掃描條形碼',
    ScanToStore: '掃描存入',
    ScanToReturn: '掃描返回',
    monthArr: new Array('1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'),
    weekArr: new Array('星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'),
    dayFormat: '日',
    space: '',
    loadMore: '加載更多...',
    finishLoading: '加载完成',
    noMore: '没有更多了'
  },
  login: {
    LoginTitle: '登錄LoggiPonto',
    Login: '登錄',
    Username: '賬號',
    Password: '密碼'
  },
  bottom: {
    line: '客服熱線：'
  },
  index: {
    profile: '會員中心',
    Arriving: '即將到達',
    Stored: '已上架',
    Collected: '已取',
    Returns: '退件',
    Store: '上架',
    Collect: '取件',
    Courier: '退件',
    expired: '逾期回倉',
    OrderId: '訂單號碼，',
    PhoneNumber: '電話號碼'
  },
  profile: {
    TodayLogs: '當日紀錄',
    Total: '總計',
    ThisMonth: '當月',
    LocationID: '地點ID',
    LocationName: '地點名',
    Address: '地址',
    ShopContact: '商店聯繫方式',
    Username: '用戶名',
    RegisteredPhoneNumber: '註冊電話號碼',
    BusinessHours: '營業時間',
    Edit: '修改',
    Logout: '退出'
  },
  editProfile: {
    EditProfile: '編輯資料',
    LocationID: '地點ID',
    LocationNameEnglish: '地點名 (英文)',
    LocationNameChinese: '地點名 (中文)',
    AddressEnglish: '地址 (英文)',
    AddressChinese: '地址(中文)',
    ShopContact: '商店聯繫方式',
    Username: '用戶名',
    RegisteredPhoneNnumber: '註冊電話號碼',
    BusinessHours: '營業時間',
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    Sunday: '星期日',
    Rest: '休息',
    AddMoreHours: '添加營業時段',
    OpenHours: '24小時營業',
    ExceptionsOrHolidays: '特殊假期',
    AddSpecialHours: '添加或刪除特殊假期',
    Open: '開門',
    Close: '關門',
    SelectSpecialDays: '選擇特殊假期',
    OK: '確定',
    Cancel: '取消'
  },
  selectCompany: {
    ReturnCourier: '退件',
    ReturnExpired: '逾期回倉'
  },
  editRemark: {},
  expired: {
    Returns: '退件',
    Expired: '已逾期'
  },
  barCode: {
    PleaseAim: '請對準條形碼',
    manually: '輸入條形碼',
    Loading: '加載中...',
    mismatch: '該包裹與取件碼不匹配'
  },
  qrCode: {
    PleaseAim: '請對準二維碼'
  },
  enterBarCode: {
    EnterBarcode: '輸入條形碼',
    EnterName: '輸入客戶姓名',
    EnterID: '輸入國民身分證號碼'
  },
  enterPIN: {
    EnterPIN: '輸入取件碼',
    ScanApp: '掃描二維碼'
  },
  success: {
    Note: '備註 (可選) ：如：包裹位置',
    ScanParcel: '掃描包裹位置',
    EditNote: '編輯備註',
    CollectSuccess: '取件成功',
    StoreSuccess: '上架成功',
    ReturnSuccess: '退件成功',
    Success: '成功'
  },
  details: {
    OrderDetails: '訂單詳情',
    OrderID: '訂單號',
    Logistics: '物流公司',
    Recipient: '收件人',
    TimeStored: '上架時間',
    Notes: '備註',
    Edit: '修改',
    ScanBarcode: '掃描條形碼',
    ScanToStore: '掃描存入',
    ScanToReturn: '掃描返回',
    TimeCollected: '取件時間',
    EditNotes: '修改備註',
    ScanParcel: '掃描包裹'
  },
  total: {
    Total: '總計',
    Completed: '已完成',
    InProgress: '進行中'
  },
  todayLogs: {
    TodayLogs: '當日紀錄'
  },
  month: {
    TimeStored: '上架時間',
    TimeCollected: '取件時間'
  },
  thisMonth: {
    ThisMonth: '當月'
  },
  searchResult: {
    CannotFind: '找不到訂單',
    TimeStored: '上架時間',
    TimeCollected: '取件時間',
    TimeReturned: '退件時間'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js